/**
 * The two constants the Map page and the guide share, and the one comparison.
 *
 * Apart from the component so the page and the guide import what they need without
 * pulling MapLibre in: `HomeMap` is loaded lazily, and a constant living beside it would
 * be a static import of the whole library.
 */

import type { MapHome, MapView } from '@taxi/api-client';
import { resolveMapView } from '@taxi/api-client';

import type { MapConfiguration } from '../../map/api';
import type { HomeView } from './HomeMap';

/** Where the small map opens for a firm that has said nothing: Europe, obviously unset. */
export const NOWHERE_IN_PARTICULAR = { longitude: 15, latitude: 48, zoom: 4 };

/** A city, for a view that is a point without a zoom of its own. */
export const CITY_ZOOM = 11;

/** What the page opens on: the same rule every map runs, with this map's own zoom. */
export function openingView(home: MapHome | null, configuration: MapConfiguration | null): MapView {
  return resolveMapView(home, configuration, { zoom: CITY_ZOOM, nowhere: NOWHERE_IN_PARTICULAR });
}

/** Whether a map has been moved off a view, within what is worth saving. */
export function sameView(a: HomeView, b: HomeView): boolean {
  return (
    Math.abs(a.longitude - b.longitude) < 0.00001 &&
    Math.abs(a.latitude - b.latitude) < 0.00001 &&
    Math.round(a.zoom) === Math.round(b.zoom)
  );
}
